import {WlTextInput} from "../../../common/ts/webcomponents/textInput/textInput.component";
import {WlBrandedButton} from "../../../common/ts/webcomponents/brandedButton/button.component";
import {WlModal} from "../../../common/ts/webcomponents/modal/modal.component";
import PageData from "../../../common/ts/PageData";
import {WlClick} from "../../../common/ts/webcomponents/events/WlClick";
import AdFormService, {ApplyOperationType, LeadContactData} from "../../../common/ts/services/AdFormService";
import {Section} from "../../../common/ts/services/Section";
import {WlContactForm} from "./WlContactForm";

export class MiniSerpUnitContactModal {
    static readonly MODAL_CONTENT_SELECTOR = '.unit-contact-form-content';
    static readonly NAME_INPUT_SELECTOR = '.name-input';
    static readonly PHONE_INPUT_SELECTOR = '.phone-input';
    static readonly EMAIL_INPUT_SELECTOR = '.email-input';
    static readonly MESSAGE_INPUT_SELECTOR = '.message-input';
    static readonly APPLY_BUTTON_SELECTOR = '.apply-button';
    static readonly SUCCESSFUL_APPLY_MESSAGE_SELECTOR = '.on-success';

    private readonly contactForm: WlContactForm;
    private readonly applyButton: WlBrandedButton | null;
    private readonly successMessageContainer: HTMLElement | null
    private readonly contentContainer: HTMLElement | null

    private readonly pageData: PageData;
    private readonly operationType: ApplyOperationType;
    private readonly wlModal: WlModal;
    private readonly adFormService: AdFormService;

    private currentUnitId: string = '';

    constructor(parameters: {
        modal: WlModal,
        pageData: PageData,
        operationType: ApplyOperationType
    }) {
        const {
            modal: wlModal,
            pageData: pageData,
            operationType
        } = parameters;
        this.pageData = pageData;
        this.wlModal = wlModal;
        this.operationType = operationType;
        this.adFormService = new AdFormService();

        const emailInput = wlModal.querySelector<WlTextInput>(MiniSerpUnitContactModal.EMAIL_INPUT_SELECTOR);
        const nameInput = wlModal.querySelector<WlTextInput>(MiniSerpUnitContactModal.NAME_INPUT_SELECTOR);
        const phoneInput = wlModal.querySelector<WlTextInput>(MiniSerpUnitContactModal.PHONE_INPUT_SELECTOR);
        const messageInput = wlModal.querySelector<WlTextInput>(MiniSerpUnitContactModal.MESSAGE_INPUT_SELECTOR);
        this.contactForm = new WlContactForm({
            nameInput: nameInput!,
            phoneInput: phoneInput!,
            emailInput: emailInput!,
            messageInput: messageInput!,
            pageData: this.pageData
        });
        this.contactForm.init();

        this.applyButton = wlModal.querySelector<WlBrandedButton>(MiniSerpUnitContactModal.APPLY_BUTTON_SELECTOR);

        this.successMessageContainer = this.wlModal.querySelector<HTMLElement>(MiniSerpUnitContactModal.SUCCESSFUL_APPLY_MESSAGE_SELECTOR);
        this.contentContainer = this.wlModal.querySelector<HTMLElement>(MiniSerpUnitContactModal.MODAL_CONTENT_SELECTOR);
    }

    init() {
        this.registerEvents();
    }

    openForUnitId(unitId: string) {
        this.resetBlocksVisibility();
        this.currentUnitId = unitId;
        this.contactForm.preFill();

        this.wlModal.open();
        this.adFormService.sendApplyImpression({
            pageViewId: this.pageData.pageViewId,
            propertyAdId: unitId,
            section: Section.SECTION_ADPAGE_PROJECTS_MODEL_CONTACT,
            step: 1,
            isProject: false,
        })
    }

    private resetBlocksVisibility() {
        this.successMessageContainer?.classList.remove('visible');
        this.contentContainer?.classList.remove('hidden');
    }

    private registerEvents() {
        this.applyButton?.listenToClickEvent((clickEvent: WlClick) => {
            clickEvent.stopImmediatePropagation()
            if (this.contactForm.areAllFieldsValid()) {
                this.adFormService.leadContactApply(this.getApplyPayload())
                this.showSuccessMessage();
                this.contactForm.save();
            }
        })
    }

    private showSuccessMessage() {
        this.successMessageContainer?.classList.add('visible')
        this.contentContainer?.classList.add('hidden');
    }

    private getApplyPayload(): LeadContactData {
        const contact = this.contactForm.contact();
        return {
            pageViewId: this.pageData.pageViewId,
            propertyAdId: this.currentUnitId,
            userName: contact.name,
            userEmail: contact.email,
            userPhone: contact.phone,
            message: contact.message,
            section: Section.SECTION_ADPAGE_PROJECTS_MODEL_CONTACT,
            operationType: this.operationType,
        };
    }
}
